<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/hspoei/tc-custom/9780226772813.jpg?1730578250472" alt="This image is the cover for the book Black Ice Score, The Parker Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Black Ice Score, The Parker Novels
      </h1>
      <p class="bookDescription body article font2">
        <p>A corrupt African colonel has converted half his country’s wealth into diamonds and smuggled them to a Manhattan safe house. Four upstanding citizens plan to rescue their new nation by stealing the diamonds back—with the help of a “specialist”: Parker. Will Parker break his rule against working with amateurs and help them because his woman would be disappointed if he doesn’t? Or because three hired morons have threatened to kill him and his woman if he does? They thought they were buying an advantage, but what they get is a predated death certificate.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Richard Stark, Dennis Lehane
      </h2>
      
      <p class="authorDescription body article"><B>Richard Stark</B> was one of the many pseudonyms of Donald E. Westlake (1933-2008), a prolific author of noir crime fiction. In 1993 the Mystery Writers of America bestowed the society’s highest honor on Westlake, naming him a Grand Master.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?59d0853e